export default {
  'fr-CA': {
    activerecord: {
      errors: {
        messages: {
          record_invalid: 'La validation a échoué : %{errors}',
          restrict_dependent_destroy: {
            has_one: "Vous ne pouvez pas supprimer l'enregistrement car une personne à charge %{record} existe",
            has_many: "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
          },
        },
      },
    },
    errors: {
      format: '%{attribute} %{message}',
      messages: {
        accepted: 'doit être accepté(e)',
        blank: 'doit être rempli(e)',
        present: 'doit être vide',
        confirmation: 'ne concorde pas avec %{attribute}',
        empty: 'doit être rempli(e)',
        equal_to: 'doit être égal à %{count}',
        even: 'doit être pair',
        exclusion: "n'est pas disponible",
        greater_than: 'doit être supérieur à %{count}',
        greater_than_or_equal_to: 'doit être supérieur ou égal à %{count}',
        inclusion: "n'est pas inclus(e) dans la liste",
        invalid: "n'est pas valide",
        less_than: 'doit être inférieur à %{count}',
        less_than_or_equal_to: 'doit être inférieur ou égal à %{count}',
        model_invalid: 'Validation échouée: %{errors}',
        not_a_number: "n'est pas un nombre",
        not_an_integer: 'doit être un nombre entier',
        odd: 'doit être impair',
        required: 'doit exister',
        taken: "n'est pas disponible",
        too_long: {
          one: "est trop long (pas plus d'un caractère)",
          other: 'est trop long (pas plus de %{count} caractères)',
        },
        too_short: {
          one: 'est trop court (au moins un caractère)',
          other: 'est trop court (au moins %{count} caractères)',
        },
        wrong_length: {
          one: 'ne fait pas la bonne longueur (doit comporter un seul caractère)',
          other: 'ne fait pas la bonne longueur (doit comporter %{count} caractères)',
        },
        other_than: 'doit être différent de %{count}',
      },
      template: {
        body: 'Veuillez vérifier les champs suivants : ',
        header: {
          one: "Impossible d'enregistrer ce %{model} : 1 erreur",
          other: "Impossible d'enregistrer ce %{model} : %{count} erreurs",
        },
      },
    },
    helpers: {
      select: {
        prompt: 'Veuillez sélectionner',
      },
      submit: {
        create: 'Créer un %{model}',
        submit: 'Enregistrer ce %{model}',
        update: 'Modifier ce %{model}',
      },
    },
    number: {
      currency: {
        format: {
          delimiter: ' ',
          format: '%n %u',
          precision: 2,
          separator: ',',
          significant: false,
          strip_insignificant_zeros: false,
          unit: '$',
        },
      },
      format: {
        delimiter: ' ',
        precision: 3,
        separator: ',',
        significant: false,
        strip_insignificant_zeros: false,
      },
      human: {
        decimal_units: {
          format: '%n %u',
          units: {
            billion: 'Milliard',
            million: 'Million',
            quadrillion: 'Million de milliards',
            thousand: 'Millier',
            trillion: 'Mille milliard',
            unit: '',
          },
        },
        format: {
          delimiter: '',
          precision: 3,
          significant: true,
          strip_insignificant_zeros: true,
        },
        storage_units: {
          format: '%n %u',
          units: {
            byte: {
              one: 'Octet',
              other: 'Octets',
            },
            gb: 'Go',
            kb: 'ko',
            mb: 'Mo',
            tb: 'To',
          },
        },
      },
      percentage: {
        format: {
          delimiter: '',
          format: '%n%',
        },
      },
      precision: {
        format: {
          delimiter: '',
        },
      },
    },
    support: {
      array: {
        last_word_connector: ' et ',
        two_words_connector: ' et ',
        words_connector: ', ',
      },
    },
  },
};
